import { apiClientAuth } from "../http/httpClient";


export function ExpenseApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
        
       /**
        * POST /api/expenses
        * @desc    Create a new expense record
        * @access  Public
        * @param   {string} type - Type of expense (3-100 chars) - required
        * @param   {string} description - Description of expense (10-2000 chars) - required
        * @param   {number} amount - Amount of expense (must be > 0) - required
        * @param   {string} document - Document path/filename (3-255 chars) - required
        * @param   {integer} userId - User ID who created expense (must be valid user) - required
        * @returns {Object} Success status with new expense data
        */
        insert : (expenses) => https.post("/api/expenses", expenses), 

       /**
        * GET /api/expenses
        * @desc    Retrieve all expenses
        * @access  Private (Admin)
        * @returns {Object} Array of all expenses with user information sorted by createdAt DESC
        */
        findAll: () => https.get(`/api/expenses`),

       /**
        * PUT /api/expenses/:id
        * @desc    Update an expense record with history tracking
        * @access  Private (Admin)
        * @param   {integer} id - Expense ID - required
        * @param   {string} type - New type of expense (optional, 3-100 chars)
        * @param   {string} description - New description (optional, 10-2000 chars)
        * @param   {number} amount - New amount (optional, must be > 0) - old amount moved to oldAmount
        * @param   {string} document - New document path (optional, 3-255 chars) - old path moved to oldDocument
        * @param   {string} adminEmail - Administrator email (required, must be valid) - sets admin field
        * @returns {Object} Updated expense with old values preserved in oldAmount and oldDocument fields
        */
        update: (id, expenses) => https.put(`/api/expenses/${id}`, expenses),

       /**
        * GET /api/expenses/:id
        * @desc    Retrieve single expense record by ID
        * @access  Private (Admin)
        * @param   {integer} id - Expense ID - required
        * @returns {Object} Expense data with user information
        */
        findOne: (id) => https.get(`/api/expenses/${id}`),

        

      };
}

